import { useParams } from 'react-router';
import { useSelector } from 'react-redux';

import get from 'lodash/get';

import useProducts from './use-products';

import product, { skus } from 'src/common/config/product';
import { findProductById, findProductVariant } from 'src/common/utils/product';

import { getProductCustomisation } from '../../store/selectors/product';

const useProductKey = (productId) => {
  if (!productId) {
    const { productSlug } = useParams();
    return product.findKeyBy.slug(productSlug);
  }

  return product.findKeyBy.sku(productId);
};

export default (productId) => {
  const products = useProducts();
  const productKey = useProductKey(productId);

  productId = productId || skus[productKey];

  const product = findProductById(products, productId);
  const productCustomisation = useSelector(getProductCustomisation);

  const productVariant = findProductVariant(get(product, 'variants'), productCustomisation);

  return {
    product,
    productId,
    productKey,
    productVariant,
    productCustomisation,
  };
};
